import { useGlobalState } from "../GlobalStates";
import { upsertNotificationAuthRequired } from "../services/notifications";

export const useUpdateWaitlist = () => {
  const [, setUser] = useGlobalState("user");

  return async (trip_id, project_id, notify, soldOut = false, waitlist = false, saveProject = false) => {
    // Update user state to track waitlisted items
    // If trip_id is provided, track by trip_id
    // If only project_id is provided, track by project_id
    setUser((u) => {
      let newState = { ...u };
      if (trip_id) {
        newState.tripIdToWaitlist = {
          ...u.tripIdToWaitlist,
          [trip_id]: true,
        };
      }
      if (project_id && saveProject) {
        newState.projectIdToSaved = {
          ...(u.projectIdToSaved || {}),
          [project_id]: true,
        };
      }
      return newState;
    });

    try {
      await upsertNotificationAuthRequired(trip_id, project_id, notify, soldOut, waitlist, saveProject).catch(
        (e) => {
          console.error("Error upserting notification:", e);
        }
      );
    } catch (e) {
      // Revert state on error
      setUser((u) => {
        let newState = { ...u };
        if (trip_id) {
          newState.tripIdToWaitlist = {
            ...u.tripIdToWaitlist,
            [trip_id]: false,
          };
        }
        if (project_id && saveProject) {
          newState.projectIdToSaved = {
            ...(u.projectIdToSaved || {}),
            [project_id]: false,
          };
        }
        return newState;
      });
    }
  };
};